// src/components/OurApproach/OurApproach.js
import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
// Icon for Bullet Points (Keep this if you still want the checkmark from code, or replace with img too)
import { BsPatchCheckFill } from "react-icons/bs";


import "./OurApproach.css";

// --- IMPORT YOUR MAIN IMAGES ---
import imgMission from "../../../assets/About/OurApproach/mission-image.jpg.png";
import imgVision from "../../../assets/About/OurApproach/mission-image.jpg (1).png";
import imgValue from "../../../assets/About/OurApproach/mission-image.jpg (2).png";

// --- IMPORT YOUR ICON IMAGES ---
// Make sure these paths match your actual icon filenames
import iconTarget from "../../../assets/About/OurApproach/SVG1.png";
import iconGrid from "../../../assets/About/OurApproach/SVG (1).png";
import iconDiamond from "../../../assets/About/OurApproach/SVG (2).png";

const OurApproach = () => {


  // DATA STRUCTURE
  const approachData = [
    {
      id: "mission",
      label: "Our Mission",
      iconImg: iconTarget, // Use the imported image variable
      img: imgMission,
      desc: "To deliver reliable, high-quality automotive stamped components through precision manufacturing, robust in-house tooling, and continuous process improvement.",
      points: [
        "Precision metal stamping for automotive applications",
        "Strong focus on quality, safety, and compliance",
        "On-time delivery through efficient processes",
        "Continuous improvement and cost optimization",
      ],
    },
    {
      id: "vision",
      label: "Our Vision",
      iconImg: iconGrid, // Use the imported image variable
      img: imgVision,
      desc: "To be a trusted automotive stamping partner recognized for manufacturing excellence, consistent quality, and long-term customer relationships.",
      points: [
        "Preferred supplier for OEMs and Tier-1 customers",
        "Scalable manufacturing with modern infrastructure",
        "Continuous technological advancement in tooling & automation",
        "Sustainable and responsible manufacturing practices",
      ],
    },
    {
      id: "value",
      label: "Our Value",
      iconImg: iconDiamond, // Use the imported image variable
      img: imgValue,
      desc: "Our values guide every aspect of our operations—from tool room engineering to shop-floor execution and customer engagement.",
      points: [
        "Quality & process discipline",
        "Integrity and transparency",
        "Customer-focused execution",
        "Safety, compliance, and responsibility",
      ],
    },
  ];

  const [activeTab, setActiveTab] = useState(approachData[0]);

  return (
    <section className="approach-section">
      {/* 1. Background Image Top Half */}
      <div className="approach-bg-top"></div>

      <Container>
        {/* 2. Top Header Content */}
        <Row className="approach-header-content">
          <Col lg={7} md={12}>
            <span className="approach-label">Our Approach</span>
            <h2 className="approach-title">
              Driving Sustainable Automotive Manufacturing

            </h2>
          </Col>
          <Col lg={5} md={12}>
            <p className="approach-desc-side">
              Dynamic Stamping follows a structured, quality-driven manufacturing approach, supported by strong tooling control, process discipline, and continuous improvement to ensure long-term value for OEM and Tier-1 customers.
            </p>
          </Col>
        </Row>

        {/* 3. The Floating White Card */}
        <div className="approach-card">
          {/* A. Tabs Header */}
          <div className="approach-tabs-head">
            {approachData.map((item) => (
              <div
                key={item.id}
                className={`approach-tab-btn ${activeTab.id === item.id ? "active" : ""}`}
                onClick={() => setActiveTab(item)}
              >
                {/* CHANGED: Using img tag instead of React Icon */}
                <img
                  src={item.iconImg}
                  alt={item.label}
                  className="tab-icon-img"
                />
                <span className="tab-text">{item.label}</span>
              </div>
            ))}
          </div>

          {/* B. Tab Content Body */}
          <div className="approach-body">
            <Row key={activeTab.id} className="fade-in-tab align-items-center">
              {/* Text Side */}
              <Col lg={6} md={12}>
                <p className="body-desc">{activeTab.desc}</p>
                <ul className="approach-points">
                  {activeTab.points.map((pt, idx) => (
                    <li key={idx} className="ap-point-item">
                      <BsPatchCheckFill className="ap-point-icon" />
                      {pt}
                    </li>
                  ))}
                </ul>
              </Col>

              {/* Image Side */}
              <Col lg={6} md={12}>
                <div className="approach-img-wrapper">
                  <img
                    src={activeTab.img}
                    alt={activeTab.label}
                    className="approach-img"
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default OurApproach;
